<template>
  <header class="clearfix">
    <Logo />
    <Tabs />
    <SearchBar />
    <SignIn />
  </header>
  
</template>

<script>
import Logo from "./Logo";
import Tabs from "./Tabs";
import SearchBar from "./SearchBar";
import SignIn from "./SignIn";
export default {
  components: {
    Logo,
    Tabs,
    SearchBar,
    SignIn,
  },
};
</script>

<style spoed>
header {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  height: 64px;
  min-width: 1400px;
  padding-left: 35px;
  padding-right: 40px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
}
</style>